export const marcasBrands = [
  { image: "https://grupomv.mx/images/2025/productos/mvexpress/fotos/logopenafiel.png",    route: "/101List",              name: "Peñafiel",      accent: "#0D47A1" },
  { image: "https://i0.wp.com/lfa.mx/2018/wp-content/uploads/2018/02/electrolit-logo.png?fit=600%2C600&ssl=1", route: "/101-ElectrolitView", name: "Electrolit",    accent: "#00838F" },
  { image: "https://th.bing.com/th/id/OIP.t2Gbf1ArhYU5L2AKNUHZpQHaFI?rs=1&pid=ImgDetMain",                   route: "/101-JackDanielsView",name: "Jack Daniel's", accent: "#1B1B1B" },
  { image: "https://grupomv.mx/images/logos/10.png",                                        route: "/101-NewMix",           name: "New Mix",       accent: "#6A1B9A" },
  { image: "https://th.bing.com/th/id/OIP.JE5lQeQFTIDRx7xOAWzt6QAAAA?rs=1&pid=ImgDetMain",route: "/103-redbull",          name: "Red Bull",      accent: "#B71C1C" },
  { image: "https://http2.mlstatic.com/D_Q_NP_640619-MLA28280782002_102018-F.jpg",          route: "/101-CaribeCoolerView", name: "Caribe Cooler", accent: "#00695C" },
  { image: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/0013/6452/brand.gif?itok=bBsc-K9p", route: "/101-BoonesView", name: "Boones",     accent: "#C2185B" },
  { image: "https://sitecoreaudioprod.umusicpub.com/sitecore_media/1B01EEBD-C4B8-4C75-8E79-C7F0131FC0DA.jpg",  route: "/101-vuala",     name: "Vualá",      accent: "#E65100" },
  { image: "https://www.clamato.com/img/clamato-logo-large.png",                            route: "/101-ClamatoView",      name: "Clamato",       accent: "#B71C1C" },
  { image: "https://www.nissinfoods.com/wp-content/uploads/2023/03/cup-noodles-nissin-1.png",route: "/141-nissin",          name: "Nissin",        accent: "#E65100" },
];

export const marcasCategorias = [
  {
    brand: "Refrescos", category: "Refrescos", route: "/101List",
    image: "https://m.media-amazon.com/images/I/61tArldLWVL._AC_UF350,350_QL80_.jpg",
    gradient: "linear-gradient(135deg, #E65100 0%, #EF6C00 100%)",
    icon: "mdi-cup-water",
  },
  {
    brand: "Energéticas", category: "Energéticas", route: "/100-EnergetizantesView",
    image: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/74fd09177758701.64dc4a81f1ab3.png",
    gradient: "linear-gradient(135deg, #0D47A1 0%, #1565C0 100%)",
    icon: "mdi-lightning-bolt",
  },
  {
    brand: "Preparadas", category: "Ready to drink", route: "/101-NewMix",
    image: "https://m.media-amazon.com/images/I/71ykFJMiUZL.jpg",
    gradient: "linear-gradient(135deg, #4A148C 0%, #7B1FA2 100%)",
    icon: "mdi-glass-cocktail",
  },
  {
    brand: "Clamato", category: "Bebidas", route: "/101-ClamatoView",
    image: "https://m.media-amazon.com/images/I/815-WNfqyJL.jpg",
    gradient: "linear-gradient(135deg, #004D40 0%, #00796B 100%)",
    icon: "mdi-bottle-tonic",
  },
];

// Todas las URLs de imágenes estáticas para precargar
export const allStaticImages = [
  ...marcasBrands.map(b => b.image),
  ...marcasCategorias.map(c => c.image),
];
